import * as React from "react";
import styles from "./NotificationManager.module.scss";

const Notification = (props) => {
  const { destroy, content, title, duration = 5000, id } = props;
  const [startCalculateDurationProgress, setStartCalculateDurationProgress] = React.useState(false);

  React.useEffect(() => {
    if (!duration) return;

    const timer = setTimeout(() => {
      destroy();
    }, duration);

    setTimeout(() => {
      setStartCalculateDurationProgress(true)
    }, 0)

    return () => clearTimeout(timer);

  }, [destroy, duration]);

  return (
    <div className={styles.notification}>
      <div className={'d-flex align-items-center'}>
        <div className={styles.icon}>
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M23.0007 42.1667C33.5861 42.1667 42.1673 33.5855 42.1673 23C42.1673 12.4146 33.5861 3.83334 23.0007 3.83334C12.4152 3.83334 3.83398 12.4146 3.83398 23C3.83398 33.5855 12.4152 42.1667 23.0007 42.1667Z" fill="#02DEAB"/>
            <path d="M20.2787 29.8617C19.8954 29.8617 19.5312 29.7083 19.2629 29.44L13.8387 24.0158C13.2829 23.46 13.2829 22.54 13.8387 21.9842C14.3946 21.4283 15.3146 21.4283 15.8704 21.9842L20.2787 26.3925L30.1304 16.5408C30.6863 15.985 31.6063 15.985 32.1621 16.5408C32.7179 17.0967 32.7179 18.0167 32.1621 18.5725L21.2946 29.44C21.0262 29.7083 20.6621 29.8617 20.2787 29.8617Z" fill="#02DEAB"/>
          </svg>
        </div>
      </div>
      <div className={styles.message}>
        <div className={styles.title}>
          <div>{ title }</div>
          <div className={'cursor-pointer'} onClick={destroy}>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.75" y1="-0.75" x2="12.326" y2="-0.75" transform="matrix(-0.713777 0.700373 -0.713777 -0.700373 13.5254 3.27074)" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M4.81445 3.88126L13.4878 12.3918" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
        </div>
        <div className={styles.content}>
          { content }
        </div>
      </div>
      <div className={styles.progressBarWrapper}>
        <div className={styles.progress} style={{width: startCalculateDurationProgress ? "0%" : "100%", transition: `width ${duration}ms linear`}}>

        </div>
      </div>
    </div>
  )
}

const shouldRerender = (prevProps, nextProps) => {
  return prevProps.id === nextProps.id;
};

export default React.memo(Notification, shouldRerender)